import { createSlice } from '@reduxjs/toolkit';
import designListSlice from '../../redux/slices/designListSlice';
import { CHECKBOX_FILTERS } from './constants';

const filterbarSlice = createSlice({
	name: 'filterbar',
	slice: 'filterbar',
	initialState: {
		filterGroups: {},
		checkedFilters: {},
		rangeFilterValues: {}
	},
	reducers: {
		setCheckedFilters(state, action) {
			state.checkedFilters[action.payload.type] = action.payload.filters;
		},
		changeRangeFilterValues(state, action) {
			state.rangeFilterValues[action.payload.filter].values = action.payload.values;
		},
		clearFilters(state, action) {
			for (const [filterName, filter] of Object.entries(action.payload)) {
				if (filter.min !== filter.max) {
					state.rangeFilterValues[filterName].values = [filter.min, filter.max];
				}
			}

			CHECKBOX_FILTERS.forEach(cbFilterCategory => {
				state.checkedFilters[cbFilterCategory.name] = [];
			});
		}
	},
	extraReducers: {
		// Clear state before new data is fetched
		[designListSlice.actions.setFetchDesignListData](state, action) {
			if (action.payload) {
				CHECKBOX_FILTERS.forEach(cbFilterCategory => {
					state.checkedFilters[cbFilterCategory.name] = [];
				});
				state.rangeFilterValues = {};
			}
		},
		// Process filters after new data is fetched
		[designListSlice.actions.setFiltersConstants](state, action) {
			const cbFilters = {};

			CHECKBOX_FILTERS.forEach(cbFilterGroup => {
				cbFilters[cbFilterGroup.name] = [];

				if (cbFilterGroup.name === 'icPackage') {
					let packages = new Set();

					action.payload.items.forEach(design => {
						packages.add({
							name: design.icPackage,
							label: design.icPackage
						});
					});

					packages = Array.from(packages);
					cbFilters.icPackage = packages
						.filter((v, i, a) => a.findIndex(t => t.name === v.name) === i)
						.sort((a, b) => (a.name > b.name ? 1 : -1));
					state.checkedFilters.icPackage = [];
				} else {
					cbFilterGroup.filters.forEach(cbFilter => {
						if (
							cbFilter.forced ||
							action.payload.items.filter(
								design =>
									(cbFilterGroup.booleanFilters && design[cbFilter.name]) ||
									design[cbFilterGroup.name] === cbFilter.name
							).length > 0
						) {
							cbFilters[cbFilterGroup.name].push(cbFilter);
						}
					});
				}

				if (cbFilters[cbFilterGroup.name].length < 1) {
					delete cbFilters[cbFilterGroup.name];
				} else {
					state.checkedFilters[cbFilterGroup.name] = [];
				}
			});

			state.filterGroups = cbFilters;

			// RF
			const rfValues = {};
			action.payload.rangeFilters.forEach(rangeFilter => {
				if (rangeFilter.min !== rangeFilter.max) {
					rfValues[rangeFilter.name] = {
						values: [rangeFilter.min, rangeFilter.max]
					};
				}
			});

			state.rangeFilterValues = rfValues;
		}
	}
});

export default filterbarSlice;
